import { isLoggedIn, suspendedAccount } from '../../requests/loader';
import store from '../../store';
import { setAacceptedTerms } from '../../reducers/user';
import Utils, {getSuspendedAccountLabels}  from '../Utils';
import LayersControl from '../../utils/LayersControl';
import utilsIsSticky from '../../utils/user/IsSticky';
import AAF from 'src/AAF/AAF';

import {AAF_MODAL_SUSPENDED_ACCOUNT, HIDE_MODAL, showModal,
  MODAL_POLITICAS, MODAL_POLITICA_DE_PRIVACIDAD,MODAL_TERMINOS_Y_CONDICIONES,
} from 'src/actions/modal';

class UtilsIsLoggedIn {
  constructor() {

    this.default = 24;
    this.defaultSuspendedAccount = 1;
    this.isLoggedInInterval = null;
    this.suspendedAccountInInterval = null;
    this.intervaltime = null;
    this.intervaltimeSuspendedAccount = null;
    this.intervalValidatorTimer = null;
    this.intervalSuspendedAccount = null;
    this.intervalAcceptedTerms = null;

    this.setIntervalIsLoggedIn = this.setIntervalIsLoggedIn.bind(this);
    this.setIntervalValidatorTimer = this.setIntervalValidatorTimer.bind(this);
    this.setIntervalSuspendedAccount = this.setIntervalSuspendedAccount.bind(this);
    this.showSuspendedAccount = this.showSuspendedAccount.bind(this);

  }

  setIntervalIsLoggedIn(history) {
    let hours = null;

    if (!this.intervaltime) {
      try {
        hours = parseFloat(Utils.getAPARegionalized('isloggedin_refresh_hours_time', 'hour_refresh', this.default));

      } catch (e) {
        hours = this.default;
      }
      this.intervaltime = hours * 60 * 60 * 1000;
    }

    if (this.isLoggedInInterval) {
      clearInterval(this.isLoggedInInterval);
      this.isLoggedInInterval = null;
    }

    this.isLoggedInInterval = setInterval(() => {
      return isLoggedIn()
        .then(result => {
          const user = result.response ? result.response : {};
          AAF.Resilence.filterIsloggedin(result, 'Interval', history);
        }).catch((err) => {
          console.error('isLoggedIn failed when interval, user NOT logged in', err);
          // Se deja como estaba en ott
          AAF.Resilence.filterIsloggedin(null, 'Interval', history);
        });
    }, this.intervaltime);
  }

  setIntervalValidatorTimer(){

    const {user: {isLoggedIn : isUserLoggedIn, userDetectWS} = {}} = store.getState();

    if (!isUserLoggedIn || !Utils.isNullOrUndefined(userDetectWS)) {
      return;
    }

    const settings = this.getValidatorTimerSetting();

    if (settings.enable){

      const msInterval = settings.time * 60 * 1000;
      if (this.intervalValidatorTimer){
        clearInterval(this.intervalValidatorTimer);
        this.intervalValidatorTimer = null;
      }

      this.intervalValidatorTimer = setInterval(() => {
        const stopIntervalAcceptedTerms = () =>{
          clearInterval(this.intervalAcceptedTerms);
          this.intervalAcceptedTerms = null;
        }
        return isLoggedIn()
        .then(result => {

          const {response : {accepted_terms} = {} } = result || {};

          if (accepted_terms === 0) {
            if (!LayersControl.isPlayerVisible()){
              this.showPrivacyPolicyModal((accepted)=>{
                if (accepted) store.dispatch(setAacceptedTerms(1));
              });
            } else {

              if (this.intervalAcceptedTerms){
                stopIntervalAcceptedTerms();
              }

              this.intervalAcceptedTerms = setInterval(() => {
                if (!LayersControl.isPlayerVisible()){

                  this.showPrivacyPolicyModal((accepted)=>{
                    if (accepted) store.dispatch(setAacceptedTerms(1));
                  });
                  stopIntervalAcceptedTerms();
                }

              }, 1000);
            }

          }

          const {response : {is_user_logged_in : isLoggedin, userDetectWS} = {}} = result;
        if (!isLoggedin){
            this.logout();
          }
        });
      }, msInterval );

    }
  }


  showPrivacyPolicyModal(handleModal = () => {}, checked = false){

    const modal = {
      modalType: MODAL_POLITICAS,
      modalProps: {
          classNameComponent: 'modal-policies',
          onAccept: () => {},
          showModal: (modalParam) => {
            this.hideModal();
            store.dispatch(showModal(modalParam))
          },
          handleBack: (checked) => {
            this.hideModal();
           this.showPrivacyPolicyModal(handleModal, checked);
          },
          handleModal,
          checked
      },
  };
    store.dispatch(showModal(modal));
  }

  showSuspendedAccount() {
    this.setIntervalSuspendedAccount();
    const modal = {
      modalType: AAF_MODAL_SUSPENDED_ACCOUNT,
      modalProps: { buttonsAlign: 'vertical' , ...getSuspendedAccountLabels()}
    };

    store.dispatch(showModal(modal))
  }

  setIntervalSuspendedAccount() {

    let hours = null;

    if (!this.intervaltimeSuspendedAccount) {
      try {
        hours = parseFloat(Utils.getAPARegionalized('suspended_refresh_hours_time', 'hour_refresh', this.defaultSuspendedAccount));

      } catch (e) {
        hours = this.defaultSuspendedAccount;
      }
      this.intervaltimeSuspendedAccount = hours * 60 * 60 * 1000;

    }

    if (this.suspendedAccountInInterval) {
      clearInterval(this.suspendedAccountInInterval);
      this.suspendedAccountInInterval = null;
    }

    this.suspendedAccountInInterval = setInterval(() => {


      const {user: {parent_id, accepted_terms = 1} = {}} = store.getState();

      const params = {
        user_id: parent_id
      }
      return suspendedAccount(params)
        .then(result => {
          const account = result.response ? result.response : {};
          const {isSuspended = false} = account;
          if(isSuspended){
            if (accepted_terms === 0) {
                this.showPrivacyPolicyModal((accepted)=>{
                  if (accepted) store.dispatch(setAacceptedTerms(1));
                  this.showSuspendedAccount();
                });
                return;
            }

            if (Utils.modalType() !== AAF_MODAL_SUSPENDED_ACCOUNT) {
                this.showSuspendedAccount();
            }
          } else {
            if (Utils.modalType() === AAF_MODAL_SUSPENDED_ACCOUNT) {
              window.location.assign('/');
            }
          }
        }).catch((err) => {
          if (Utils.modalType() === AAF_MODAL_SUSPENDED_ACCOUNT) {
            window.location.assign('/');
          }
        });
    }, this.intervaltimeSuspendedAccount);
  }

  hideModal(){
    store.dispatch({
      type: HIDE_MODAL,
  });
  }

  logout(){
    utilsIsSticky.isStickyLogout();
  }

  getValidatorTimerSetting(){
    return Utils.getApaMetadataKey('session_validation_timer', '{"enable":false, "time": 240}');
  }

  showBlueHeadBand() {
    const {user} = store.getState() || {};
    if (Utils.isPTV(user) || user.validEmail){
      return false;
    }
    else {
      const {limit = 0} = Utils.getApaMetadataKey('user_mail_validation', '{"enable":false,"limit":3}') || {};
      return user.counterValidEmail <= limit;
    }
  }

  userType() {
    const {user} = store.getState() || {};
    if (Utils.isPTV(user)){
      return true;
    } else return false;
  }

  userHasSuscriptions() {
    const {user} = store.getState() || {};
    return user.isSusc || (user.subscriptions && Object.keys(user.subscriptions).length > 0);
  }
}

const instanceUtilsIsLoggedIn = new UtilsIsLoggedIn();
//Object.freeze(instance);

export default instanceUtilsIsLoggedIn;


// WEBPACK FOOTER //
// ./src/utils/user/isLoggedIn.js